import { SVGProps } from 'react'

export function BigStar({ ...props }: SVGProps<SVGSVGElement>) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="733"
      height="913"
      fill="none"
      viewBox="0 0 733 913"
      {...props}
    >
      <path
        fill="url(#paint0_radial_3741_27208)"
        fillRule="evenodd"
        d="M732.027 456.117a1.79 1.79 0 0 0-1.405-1.743C521.95 408.372 365.789 222.443 365.55 0c-.238 222.043-155.838 407.703-363.946 454.125a2.05 2.05 0 0 0-1.603 1.992c0 .956.67 1.783 1.603 1.992C209.712 504.531 365.312 690.19 365.55 912.233c.239-222.443 156.399-408.371 365.072-454.374a1.79 1.79 0 0 0 1.405-1.742"
        clipRule="evenodd"
        opacity="0.3"
      ></path>
      <path
        fill="url(#paint1_radial_3741_27208)"
        fillRule="evenodd"
        d="M673.691 456.117c0-.704-.494-1.313-1.182-1.465C497.274 416.02 366.091 260.003 365.624 73.265c-.467 186.404-131.182 342.197-305.947 381.179a1.72 1.72 0 0 0-1.347 1.673 1.72 1.72 0 0 0 1.347 1.674c174.765 38.981 305.481 194.774 305.947 381.179.467-186.738 131.65-342.755 306.885-381.387a1.505 1.505 0 0 0 1.182-1.466"
        clipRule="evenodd"
        opacity="0.5"
      ></path>
      <path
        fill="url(#paint2_radial_3741_27208)"
        fillRule="evenodd"
        d="M621.078 456.118c0-.584-.409-1.088-.979-1.214C474.7 422.849 365.918 293.222 365.918 138.188v-71.42h-.001v71.42c0 154.757-108.393 284.197-253.4 316.543a1.424 1.424 0 0 0-1.116 1.387c0 .665.466 1.241 1.116 1.386C257.525 489.85 365.918 619.29 365.918 774.047v72.617-72.617c0-155.034 108.782-284.661 254.181-316.716.57-.125.979-.63.979-1.213"
        clipRule="evenodd"
      ></path>
      <defs>
        <radialGradient
          id="paint0_radial_3741_27208"
          cx="0"
          cy="0"
          r="1"
          gradientTransform="rotate(83.862 -1.012 91.52)scale(822.347 1645.32)"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.163" stopColor="#34CBFF"></stop>
          <stop offset="0.269" stopColor="#4DAFFC"></stop>
          <stop offset="0.401" stopColor="#B5A2E4"></stop>
          <stop offset="0.484" stopColor="#F398CA"></stop>
          <stop offset="0.618" stopColor="#F7BDC4"></stop>
          <stop offset="0.715" stopColor="#FDB697"></stop>
          <stop offset="0.834" stopColor="#FF986F"></stop>
          <stop offset="1" stopColor="#FF7FB8"></stop>
        </radialGradient>
        <radialGradient
          id="paint1_radial_3741_27208"
          cx="0"
          cy="0"
          r="1"
          gradientTransform="matrix(73.9114 686.30052 -1375.12842 148.09499 134.062 142.715)"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.163" stopColor="#34CBFF"></stop>
          <stop offset="0.269" stopColor="#4DAFFC"></stop>
          <stop offset="0.401" stopColor="#B5A2E4"></stop>
          <stop offset="0.484" stopColor="#F398CA"></stop>
          <stop offset="0.618" stopColor="#F7BDC4"></stop>
          <stop offset="0.715" stopColor="#FDB697"></stop>
          <stop offset="0.834" stopColor="#FF986F"></stop>
          <stop offset="1" stopColor="#FF7FB8"></stop>
        </radialGradient>
        <radialGradient
          id="paint2_radial_3741_27208"
          cx="0"
          cy="0"
          r="1"
          gradientTransform="rotate(84.995 12.026 163.773)scale(701.696 1147.77)"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.163" stopColor="#34CBFF"></stop>
          <stop offset="0.269" stopColor="#4DAFFC"></stop>
          <stop offset="0.401" stopColor="#B5A2E4"></stop>
          <stop offset="0.484" stopColor="#F398CA"></stop>
          <stop offset="0.618" stopColor="#F7BDC4"></stop>
          <stop offset="0.715" stopColor="#FDB697"></stop>
          <stop offset="0.834" stopColor="#FF986F"></stop>
          <stop offset="1" stopColor="#FF7FB8"></stop>
        </radialGradient>
      </defs>
    </svg>
  )
}
